import useTimeZoneClock from 'hooks/useTimeZoneClock';
import UrgentBadge from 'components/common/UrgentBadge';
import { getBackgroundStyle } from 'components/common/TableColor';
import moment from 'moment';
import React from 'react'
import { formatDuration } from 'utils/formatDuration';

const ViewTable = React.memo(({ item }) => {

    const timeZone = useTimeZoneClock(item?.datetime);
    const formattedDate = moment(timeZone).format('MMMM DD YYYY');
    const formattedTime = moment(timeZone).format('hh:mm A');

    const InfoRow = ({ label, value, toLowerCase = "" }) => (
        <div className='row_detail_tab'>
            <div className='label_view'><strong>{label}</strong></div>
            <div className={`detail_view ${toLowerCase}`}>{value || 'N/A'}</div>
        </div>
    );
    const rowDash1Style = {
        display: 'flex',
        alignItems: 'normal',
        width: '100%',
        gap: '1rem'
    };
    const rowDash2Style = {
        display: 'block',
        alignItems: 'normal',
        width: '100%',
        gap: '1rem'
    };
    const marginTopZero = {
        marginTop: 0
    };
    return (

        <div className="Table_data_show Table_data_show1 p-0 overflow-auto">
            <div className="row_dash_1" style={rowDash1Style}>
                <div className="card_table" style={marginTopZero}>

                    <div className="Table_data_show Table_data_show1 pt-0">
                        <table class="bg-primary-secondary table">
                            <tbody>
                                {/* <tr>
                                    <td class="bg-primary-secondary" style={{ width: "40%" }}>Facility: </td>
                                    <td class="bg-primary-secondary">{item?.appointment_details?.facility?.name}</td>
                                </tr> */}
                                <tr>
                                    <td class="bg-primary-secondary" style={{ width: "40%" }}>Department: </td>
                                    <td class="bg-primary-secondary">{item?.appointment_details?.department?.name}</td>
                                </tr>
                                <tr>
                                    <td class="bg-primary-secondary" style={{ width: "40%" }}>Full Address:</td>
                                    <td class="bg-primary-secondary">{item.appointment_details?.address}</td>
                                </tr>
                                <tr>
                                    <td class="bg-primary-secondary" style={{ width: "40%" }}>Street Address:</td>
                                    <td class="bg-primary-secondary">{item.appointment_details?.department?.street_address}</td>
                                </tr>
                                {item.appointment_details?.department?.city && (
                                    <tr>
                                        <td class="bg-primary-secondary" style={{ width: "40%" }}>City:</td>
                                        <td class="bg-primary-secondary">{item.appointment_details?.department?.city}</td>
                                    </tr>
                                )}
                                {item.appointment_details?.department?.state && (
                                    <tr>
                                        <td class="bg-primary-secondary" style={{ width: "40%" }}>State:</td>
                                        <td class="bg-primary-secondary">{item.appointment_details?.department?.state}</td>
                                    </tr>
                                )}
                                {item.appointment_details?.department?.zipcode && (
                                <tr>
                                    <td class="bg-primary-secondary" style={{ width: "40%" }}>Zipcode:</td>
                                    <td class="bg-primary-secondary">{item.appointment_details?.department?.zipcode}</td>
                                </tr>
                                )}
                                <tr>
                                    <td class="bg-primary-secondary" style={{ width: "40%" }}>Phone:</td>
                                    <td class="bg-primary-secondary">{item.appointment_details?.department?.phone}</td>
                                </tr>
                                <tr>
                                    <td class="bg-primary-secondary" style={{ width: "40%" }}>Cost Center:</td>
                                    <td class="bg-primary-secondary">{item.appointment_details?.department?.cost_center}</td>
                                </tr>
                                {/* <tr>
                                    <td class="bg-primary-secondary" style={{ width: "40%" }}>Language:</td>
                                    <td class="bg-primary-secondary">{item?.language?.name || item?.other_language}</td>
                                </tr> */}
                            </tbody>
                        </table>
                    </div>
                    <div className="Table_data_show Table_data_show2 pt-0">
                        <table class="bg-primary-secondary table">
                            <tbody>
                                <tr>
                                    <td class="bg-primary-secondary" style={{ width: "40%" }}>Vendor Name: </td>
                                    <td class="bg-primary-secondary">{item?.vendor?.name || item?.interpreter?.vendor?.name || 'N/A'}</td>
                                </tr>
                                {item?.interpreter_id && (
                                    <tr>
                                        <td class="bg-primary-secondary" style={{ width: "40%" }}>Interpreter Name: </td>
                                        <td class="bg-primary-secondary">{`${item?.interpreter?.first_name} ${item?.interpreter?.last_name || ''}`}</td>
                                    </tr>
                                )}
                                <tr>
                                    <td class="bg-primary-secondary" style={{ width: "40%" }}>Provider Name: </td>
                                    <td class="bg-primary-secondary">{item.appointment_details?.provider_name || 'N/A'}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    {/* <div className="Table_data_show Table_data_show2 pt-0">
                        <table class="bg-primary-secondary table">
                            <tbody>
                                <tr>
                                    <td class="bg-primary-secondary" style={{ width: "40%" }}>Special Instructions: </td>
                                    <td class="bg-primary-secondary">{item?.appointment_details?.special_instruction || 'N/A'}</td>
                                </tr>
                                <tr>
                                    <td class="bg-primary-secondary" style={{ width: "40%" }}>Brief Description: </td>
                                    <td class="bg-primary-secondary">{item.appointment_details?.breif_description || 'N/A'}</td>
                                </tr>
                                <tr>
                                    <td class="bg-primary-secondary" style={{ width: "40%" }}>Notes: </td>
                                    <td class="bg-primary-secondary">{item.appointment_details?.notes || 'N/A'}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div> */}

                </div>
                <div className="card_table" style={marginTopZero}>
                    <div className="Table_data_show Table_data_show1 pt-0 ">
                        <table class="bg-info-secondary table" style={getBackgroundStyle(item?.status)}>
                            <tbody>
                                <tr>
                                    <td className="bg-info-secondary" style={{ ...getBackgroundStyle(item?.status), width: "40%" }}>Status: </td>
                                    <td className="bg-info-secondary capitalize-status" style={getBackgroundStyle(item?.status)}>
                                        {item?.status?.replace(/_/g, ' ')}
                                        {item?.is_urgent_effective && (
                                            <UrgentBadge item={item} style={{ marginLeft: 8 }} />
                                        )}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="Table_data_show Table_data_show1 pt-0 ">
                        <table class="bg-primary-secondary table">
                            <tbody>
                                <tr>
                                    <td class="bg-primary-secondary" style={{ width: "40%" }}>Patient Name: </td>
                                    <td class="bg-primary-secondary">{item.appointment_details?.patient?.patient_name || 'N/A'}</td>
                                </tr>
                                <tr>
                                    <td class="bg-primary-secondary" style={{ width: "40%" }}>MRN:</td>
                                    <td class="bg-primary-secondary">{item.appointment_details?.patient?.mrn_number || 'N/A'}</td>
                                </tr>
                                <tr>
                                    <td class="bg-primary-secondary" style={{ width: "40%" }}>DOB:</td>
                                    <td class="bg-primary-secondary">{item.appointment_details?.patient?.birth_date || 'N/A'}</td>
                                </tr>
                                {/* <tr>
                                    <td class="bg-primary-secondary" style={{ width: "40%" }}>Medicaid ID:</td>
                                    <td class="bg-primary-secondary">{item.appointment_details?.patient?.medicaid_id || 'N/A'}</td>
                                </tr>
                                <tr>
                                    <td class="bg-primary-secondary" style={{ width: "40%" }}>Health Plan:</td>
                                    <td class="bg-primary-secondary">{item.appointment_details?.patient?.medicaid_plan || 'N/A'}</td>
                                </tr> */}
                            </tbody>
                        </table>
                    </div>
                    <div className="Table_data_show Table_data_show1 pt-0 ">
                        <table class="bg-primary-secondary table">
                            <tbody>
                                <tr>
                                    <td class="bg-primary-secondary" style={{ width: "40%" }}>Requester Name: </td>
                                    <td class="bg-primary-secondary">{item.appointment_details?.requester_name || 'N/A'}</td>
                                </tr>
                                <tr>
                                    <td class="bg-primary-secondary" style={{ width: "40%" }}>Requester Email(s): </td>
                                    <td class="bg-primary-secondary" toLowerCase={'text-lowercase'}>{item.appointment_details?.requester_email || 'N/A'}</td>
                                </tr>
                                <tr>
                                    <td class="bg-primary-secondary" style={{ width: "40%" }}>Requester Phone:</td>
                                    <td class="bg-primary-secondary">{item.appointment_details?.requester_phone || 'N/A'}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div className="row_dash_1" style={rowDash2Style}>
                <div className="Table_data_show Table_data_show1 pt-0 ">

                    <table class="bg-primary-secondary table">
                        <tbody>
                            <tr>
                                <td class="bg-primary-secondary">Special Instructions: </td>
                                <td class="bg-primary-secondary" colSpan={5}>{item?.appointment_details?.special_instruction || 'N/A'}</td>
                            </tr>
                            <tr>
                                <td class="bg-primary-secondary" >Brief Description: </td>
                                <td class="bg-primary-secondary" colSpan={5}>{item.appointment_details?.breif_description || 'N/A'}</td>
                            </tr>
                            <tr>
                                <td class="bg-primary-secondary" >Notes: </td>
                                <td class="bg-primary-secondary" colSpan={5}>{item.appointment_details?.notes || 'N/A'}</td>
                            </tr>
                            {/* Preferred interpreter gender lives with the job requirements,
                                not in Patient Information - vendors were reading a bare
                                "Gender" under the patient's DOB as the patient's gender. */}
                            <tr>
                                <td class="bg-primary-secondary" style={{ width: "20%" }}>Preferred Interpreter Gender: </td>
                                <td class="bg-primary-secondary" colSpan={5}>{item.appointment_details?.gender || 'No preference'}</td>
                            </tr>
                            <tr>
                                <td class="bg-primary-secondary" style={{ width: "20%" }}>Estimated Duration: </td>
                                <td class="bg-primary-secondary" >{formatDuration(item.duration)}</td>

                                <td class="bg-primary-secondary">Rescheduled Reason: </td>
                                <td class="bg-primary-secondary" colSpan={3}>{item?.appointment_details?.reschedule_reason || 'N/A'}</td>

                                {/* <td class="bg-primary-secondary">Priority Level:</td>
                                <td class="bg-primary-secondary">{item.appointment_details?.priority_level}</td> */}
                            </tr>
                            <tr>
                                {/* <td class="bg-primary-secondary">Special Instructions:</td>
                                <td class="bg-primary-secondary" colSpan={2}>{item.appointment_details?.special_instruction}</td>
                             */}
                                {/* <td class="bg-primary-secondary">Encounter Source: </td>
                                <td class="bg-primary-secondary">{item.appointment_details?.encounter_source || 'N/A'}</td> */}

                                <td class="bg-primary-secondary">Cancel reason: </td>
                                <td class="bg-primary-secondary" colSpan={5}>{item?.appointment_details?.cancel_reason || 'N/A'}</td>

                                {/* <td class="bg-primary-secondary">Notes:</td>
                                <td class="bg-primary-secondary">{item.appointment_assign?.notes || 'N/A'}</td> */}
                            </tr>
                            <tr>
                                <td class="bg-primary-secondary">DNC Reason:</td>
                                <td class="bg-primary-secondary" colSpan={2}>{item?.appointment_details?.dnc_reason || 'N/A'}</td>
                                <td class="bg-primary-secondary">CNC Reason:</td>
                                <td class="bg-primary-secondary" colSpan={2}>{item?.appointment_details?.cnc_reason || 'N/A'}</td>
                            </tr>
                            <tr>
                                <td class="bg-primary-secondary">Checkin Date:</td>
                                <td class="bg-primary-secondary" colSpan={2}>{item.appointment_assign?.checkin_date || 'N/A'}</td>
                                <td class="bg-primary-secondary">Checkin Time:</td>
                                <td class="bg-primary-secondary" colSpan={2}>{item.appointment_assign?.checkin_time || 'N/A'}</td>
                            </tr>
                            <tr>
                                <td class="bg-primary-secondary">Checkout Date:</td>
                                <td class="bg-primary-secondary" colSpan={2}>{item.appointment_assign?.checkout_date || 'N/A'}</td>
                                <td class="bg-primary-secondary">Checkout Time:</td>
                                <td class="bg-primary-secondary" colSpan={2}>{item.appointment_assign?.checkout_time || 'N/A'}</td>
                            </tr>
                            <tr>
                                <td class="bg-primary-secondary">Notes:</td>
                                <td class="bg-primary-secondary" colSpan={6}>{item.appointment_assign?.notes || 'N/A'}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            {/* <div className="profile-section">
                <h2>Basic Detail</h2>
                <div className='row_sec_wrapper'>
                    <InfoRow label="Appointment ID:" value={item?.appid} />
                    <InfoRow label="Status:" value={item?.status} />
                    <InfoRow label="Date:" value={item?.date} />
                    <InfoRow label="Time:" value={item?.start_time} />
                    <InfoRow label="Appointment Type:" value={item?.type} />
                    <InfoRow label="Language:" value={item?.language?.name} />
                    <InfoRow label="Facility:" value={item?.appointment_details?.facility?.abbreviation} />
                    <InfoRow label="Department:" value={item?.appointment_details?.department?.department_name} />
                    <InfoRow label="Estimated Duration:" value={formatDuration(item.duration)} />
                    <InfoRow label="Facility Address:" value={item.appointment_details?.facility?.address} />
                </div>
            </div> */}
            {/* <div className="profile-section">
                <h2>Client Information</h2>
                <div className='row_sec_wrapper'>
                    <InfoRow label="Client Name:" value={item?.accounts?.user?.name} />
                    <InfoRow label="Client Email:" value={item?.accounts?.user?.email} toLowerCase={'text-lowercase'} />
                    <InfoRow label="Client Phone:" value={item?.accounts?.phone} />
                </div>
            </div> */}
            {/* {(item?.interpreter || item?.vendor) &&
                <div className="profile-section">
                    <h2>Interpreter / Vendor</h2>
                    <div className='row_sec_wrapper'>
                        {item?.interpreter &&
                            <>
                                {item?.interpreter?.vendor ?
                                    <InfoRow label="Interpreter Name:" value={item?.interpreter?.user?.name + ' - ' + item?.interpreter?.vendor?.name} />
                                    :
                                    <InfoRow label="Interpreter Name:" value={item?.interpreter?.user?.name} />
                                }
                                <InfoRow label="Interpreter Email:" value={item?.interpreter?.user?.email} toLowerCase={'text-lowercase'} />
                                <InfoRow label="Interpreter Phone:" value={item?.interpreter?.phone} />
                            </>
                        }
                        {item?.vendor &&
                            <>
                                <InfoRow label="Vendor Name:" value={item?.vendor?.name} />
                                <InfoRow label="Vendor Email:" value={item?.vendor?.email} toLowerCase={'text-lowercase'} />
                            </>
                        }
                    </div>
                </div>
            } */}

            {/* <div className="profile-section">
                <h2>Patient Information</h2>
                <div className='row_sec_wrapper'>
                    <InfoRow label="Patient Name:" value={item.appointment_details?.patient?.patient_name} />
                    <InfoRow label="Patient Phone:" value={item.appointment_details?.patient_phone} />
                    <InfoRow label="Patient Birthdate:" value={item.appointment_details?.patient?.birth_date} />
                    <InfoRow label="MRN Number:" value={item.appointment_details?.patient?.mrn_number} />
                    <InfoRow label="Medicaid Id:" value={item.appointment_details?.patient?.medicaid_id} />
                    <InfoRow label="Medicaid Plan:" value={item.appointment_details?.patient?.medicaid_plan} />
                </div>
            </div> */}

            {/* <div className="profile-section">
                <h2>Requestor Information</h2>
                <div className='row_sec_wrapper'>
                    <InfoRow label="Requester Name:" value={item.appointment_details?.requester_name} />
                    <InfoRow label="Requester Email:" value={item.appointment_details?.requester_email} toLowerCase={'text-lowercase'} />
                    <InfoRow label="Requester Phone:" value={item.appointment_details?.requester_phone} />
                </div>
            </div> */}
            {/* <div className="profile-section">
                <h2>Appointment Detail</h2>
                <div className='row_sec_wrapper'>
                    <InfoRow label="Priority Level:" value={item.appointment_details?.priority_level} />
                    <InfoRow label="Provider Name:" value={item.appointment_details?.provider_name} />
                    <InfoRow label="Special Instruction:" value={item.appointment_details?.special_instruction} />
                    <InfoRow label="Encounter Source:" value={item.appointment_details?.encounter_source} />
                    <InfoRow label="Reschedule reason:" value={item?.appointment_details?.reschedule_reason} />
                    <InfoRow label="CNC reason:" value={item?.appointment_details?.cnc_reason} />
                    <InfoRow label="DNC reason:" value={item?.appointment_details?.dnc_reason} />
                    <InfoRow label="Cancel reason:" value={item?.appointment_details?.cancel_reason} />
                </div>
            </div> */}
            {/* <div className="profile-section">
                <h2>Checkin/Checkout Deatils</h2>
                <div className='row_sec_wrapper'>
                    <InfoRow label="Checkin Date:" value={item.appointment_assign?.checkin_date} />
                    <InfoRow label="Checkin Time:" value={item.appointment_assign?.checkin_time} />
                    <InfoRow label="Checkout Date:" value={item.appointment_assign?.checkout_date} />
                    <InfoRow label="Checkout Time:" value={item.appointment_assign?.checkout_time} />
                    <InfoRow label="Comments:" value={item.appointment_assign?.comments} />
                    <InfoRow label="Notes:" value={item.appointment_assign?.notes} />
                </div>
            </div> */}
        </div>
    )

})

export default ViewTable